import styled from 'styled-components'

import type { ChildrenProps } from '../react'

type StartContentProps = ChildrenProps & {
  icon: React.ReactNode
}
export const StartContent = (props: StartContentProps) => (
  <StartContentRoot>
    <div className={'icon'}>{props.icon}</div>
    <div>{props.children}</div>
  </StartContentRoot>
)

const StartContentRoot = styled.div`
  min-width: 85px;
  color: var(--text-11);
  display: flex;
  gap: 8px;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
